import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Text, TextProps } from '@chakra-ui/react';
import { gql } from '@src/lib/gql.ts';
export const ToolSessionSummary = props => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($toolSessionId: String!) {
        scoToolSession(toolSessionId: $toolSessionId) {
          id
          generatedSummary(generateIfStale: true)
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.toolSessionId) {
    t1 = {
      variables: {
        toolSessionId: props.toolSessionId
      }
    };
    $[1] = props.toolSessionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  if (query.loading) {
    let t2;
    if ($[3] !== props.textProps) {
      t2 = <Text {...props.textProps}>Loading...</Text>;
      $[3] = props.textProps;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (query.error) {
    let t2;
    if ($[5] !== props.textProps || $[6] !== query.error.message) {
      t2 = <Text {...props.textProps}>Error: {query.error.message}</Text>;
      $[5] = props.textProps;
      $[6] = query.error.message;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  const t2 = query.data?.scoToolSession?.generatedSummary || "Summary not available.";
  let t3;
  if ($[8] !== props.textProps || $[9] !== t2) {
    t3 = <Text {...props.textProps}>{t2}</Text>;
    $[8] = props.textProps;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};